import api from '../../REST/api';
import { tapFlashError } from '../../utils/flash';

export default async function getOpportunityWithBrandIds(opp) {
  const { brandCodes, ...rest } = opp;
  const brands = await api.getBrands({
    search: { code: brandCodes },
  });

  if (brands.length === 0) {
    tapFlashError()({
      message:
        'Please make sure that the correct brand codes have been provided.',
    });
  }

  // This is done since the first brandCode should be returned as the first brandId
  // as the copy and text assets is based on the first brand in the opportunity
  const firstBrandIndex = brands.findIndex(
    brand => brand.code === brandCodes[0],
  );
  const firstBrand = brands.splice(firstBrandIndex, 1);
  return {
    ...rest,
    brandIds: [firstBrand[0].id, ...brands.map(item => item.id)],
  };
}
